import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveTo32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMoveTo32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 4a2 2 0 0 0-2 2v2.053a2 2 0 0 0 2 2h3.5a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4.053V6h3.5v2.053zM9 13a2 2 0 0 0-2 2v2.053a2 2 0 0 0 2 2h3.5a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2zm0 4.053V15h3.5v2.053zM7 24a2 2 0 0 1 2-2h3.5a2 2 0 0 1 2 2v2.053a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2zm2 0v2.053h3.5V24zm8-11a1 1 0 1 0 2 0v-2.745A6.99 6.99 0 0 1 22 16a6.99 6.99 0 0 1-3 5.746v-2.502a1 1 0 1 0-2 0V25h6a1 1 0 1 0 0-2h-2.342A8.98 8.98 0 0 0 24 16a8.98 8.98 0 0 0-3.342-7H23a1 1 0 1 0 0-2h-6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoveTo32);
